<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="less">
@import "../static/css/main.css";
/* 关闭按钮 */
.closeBtn {
  background-color: rgba(90, 82, 255, 0.1) !important;
  color: #5a52ff !important;
  height: 55px !important;
  width: 100px !important;
  font-size: 26px !important; /*px*/
  font-weight: bold !important;
  letter-spacing: 1px !important;
}

/* 加载中提示 */
.van-toast {
  width: 230px !important;
  height: 230px !important;
  font-size: 30px; /*px*/
  line-height: 45px !important;
}

// 开关
.van-switch {
  width: 70px;
  height: 40px;
}
.van-switch__node {
  width: 40px;
  height: 40px;
}

/* 确认对话框 */
.van-dialog {
  padding: 30px !important;
  padding-bottom: 0 !important;
  box-sizing: border-box !important;
  width: 600px !important; /*弹框宽度*/
}
.van-dialog__header {
  font-size: 34px !important; /*px*/
  letter-spacing: 2px !important;
  font-weight: bold !important;
}
.van-dialog__content {
  text-align: center !important;
  font-size: 30px !important; /*px*/ /*信息文字大小*/
  color: #1A1A1A !important;
  margin-top: 40px !important;
  margin-bottom: 40px !important;
  line-height: 45px !important;
  letter-spacing: 1px !important;
}
.van-dialog__footer {
  height: 80px !important;
  .van-button{
    height: 80px !important;
  }
  .van-button--default {
    font-size: 34px !important; /*px*/
    letter-spacing: 2px !important;
  }
}

// 顶部提示
.topTip{
  padding: 30px 35px;
  box-sizing: border-box;
  position: relative;
  border-bottom: 1px solid #E6E6E6;
  background-color: #fff;
  .btn2{
      position: absolute;
      right: 3%;
      top: 50%;
      transform: translateY(-50%);
      letter-spacing: 2px !important;
  }
  p{
      &:nth-child(1){
          color: #1A1A1A;
          font-size: 32px; /*px*/
          font-weight: bold;
          letter-spacing: 3px;
          margin-bottom: 7px;
      }
      &:nth-child(2){
          color: #999999;
          font-size: 26px; /*px*/
          letter-spacing: 1px;
          width: 570px;
      }
  }
}


// 接口报错提示弹窗
.van-notify--warning{
  height: 97px; /*px*/
  font-size: 30px; /*px*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue